export const Input = (props:any) => (
        <div className="sm:items-start">
            <div className="sm:col-span-2">
            {props.label? <p>{props.label}</p> : <div></div>}
            <input
                key={props.key}
                onChange={(e) => props.onChange(props.field, e)}
                value={props.value}
                style={{ WebkitAppearance: 'none', outline: 'none' }}
                className="shadow-sm focus:ring-dustyrose focus:border-dustyrose block w-full sm:text-sm border-gray-300 px-4"
                placeholder={props.placeholder}
                type={props.type ? "password" : "text"}
            />
            </div>
            {props.errors && <p className="font-lato font-regular text-red mt-2 text-sm">{props.errors[0]}</p>}
        </div>
)